import _extends from '@babel/runtime/helpers/extends';
import React from 'react';
import PropTypes from 'prop-types';
import { a as addClassNames, c as classNamePropTypes } from './classNames-1ed461aa.js';
import { a as addSpacingClasses, m as marginPropTypes } from './spacing-0f39ba4a.js';
import { T as Typography } from './Typography-98688343.js';
import { G as Group } from './Group-0add3181.js';

const labelProps = {
  top: {
    direction: 'column',
    gap: 'xs',
    align: 'initial'
  },
  bottom: {
    direction: 'column-reverse',
    gap: 'xs',
    align: 'initial'
  },
  left: {
    direction: 'row',
    gap: 'sm',
    valign: 'center',
    align: 'initial',
    wrap: false
  },
  right: {
    direction: 'row-reverse',
    gap: 'sm',
    align: 'end',
    valign: 'center',
    wrap: false
  }
};
const typographyProps = {
  top: {
    size: 'sm',
    weight: 'bold'
  },
  bottom: {
    size: 'sm',
    weight: 'bold'
  },
  left: {
    size: 'md'
  },
  right: {
    size: 'md'
  }
};
function FormLabel({
  className,
  children,
  label,
  labelPosition,
  margin,
  fullWidth,
  required,
  wrap,
  ...otherProps
}) {
  let cssClasses = ['st_label', `st_label--${labelPosition}`];
  cssClasses = addClassNames(className, cssClasses);
  cssClasses = addSpacingClasses({
    margin,
    cssClasses
  });
  if (fullWidth) cssClasses.push('st_label--fullWidth');
  return (
    /*#__PURE__*/
    /* eslint-disable-next-line jsx-a11y/label-has-associated-control */
    React.createElement(Group, _extends({
      componentEl: "label"
    }, labelProps[labelPosition], {
      className: cssClasses.join(' ')
    }, otherProps), " ", /*#__PURE__*/React.createElement(Typography, _extends({}, typographyProps[labelPosition], {
      whiteSpace: wrap === false ? 'nowrap' : null
    }), label, required && /*#__PURE__*/React.createElement(Typography, {
      color: "lava",
      inline: true
    }, " *")), children)
  );
}
FormLabel.propTypes = {
  /** extra CSS classes, if any */
  className: classNamePropTypes,
  /** what to display as the label content */
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  /** position of label relative to input */
  labelPosition: PropTypes.oneOf(['top', 'left', 'right', 'bottom']),
  /** margin for label, if any */
  margin: marginPropTypes,
  /** whether label should take up all available space */
  fullWidth: PropTypes.bool,
  /** whether this is for a required input, will add a visual marker to the label */
  required: PropTypes.bool,
  /** whether to allow text to wrap or force to always be on one line */
  wrap: PropTypes.bool
};
FormLabel.defaultProps = {
  className: null,
  labelPosition: 'top',
  margin: null,
  fullWidth: false,
  required: false,
  wrap: false
};

export { FormLabel as F };
